export default "__VITE_ASSET__l2dXx9o0__"